export default __webpack_public_path__ + "static/media/connect.99c55c32.svg";